import { SET_CONFIRMATION_MODAL_STATE } from 'redux/actions/types' // eslint-disable-line

export const openConfirmationModal = ({
  header,
  confirmationMessage,
  confirmFunc,
  confirmFuncArgs,
}) => ({
  type: SET_CONFIRMATION_MODAL_STATE,
  payload: {
    confirmationModalVisible: true,
    header,
    confirmationMessage,
    confirmFunc,
    confirmFuncArgs,
  },
})

export const closeConfirmationModal = () => ({
  type: SET_CONFIRMATION_MODAL_STATE,
  payload: {
    confirmationModalVisible: false,
    header: '',
    confirmationMessage: '',
    confirmFunc: () => {
      console.log(
        'default confirm func, you need to input your own confirm func',
      )
    },
    confirmFuncArgs: {},
  },
})
